export default __webpack_public_path__ + "static/media/lipgloss-black.2a1347ee.svg";